import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    width: 110,
    minWidth: 110,
    height: 42,
    minHeight: 42,
    boxSizing: "border-box",
    padding: "10px 16px",
    borderRadius: 4,
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "140%",
    textTransform: "none",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.common.white,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.text.primary,
    boxShadow: "none",
    "&.MuiButton-outlined": {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.text.primary,
    },
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.common.white,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.text.primary,
      boxShadow: "none",
    },
  },
}));
